import React, {Component} from 'react'

import registerIdHelper from '@rambler-id/utils/commonjs/registerIdHelper'
import withStyles from 'isomorphic-style-loader/withStyles'
import {activateMetrics} from '../../utils/metrics'

import Header from 'containers/Header'
import Features from 'containers/Features'
import Proposal from 'containers/Proposal'
import Products from 'containers/Products'
import {Footer} from 'containers/Footer'

import styles from './styles.module.css'

class App extends Component {
  state = {
    loggedIn: undefined,
    displayName: '',
    avatarUrl: ''
  }

  componentDidMount = async () => {
    const helper = await registerIdHelper()

    activateMetrics()

    helper.addListener('login', () => this.reloadUser(helper))
    helper.addListener('logout', () => this.reloadUser(helper))
    helper.addListener('oauthlogin', () => this.reloadUser(helper))
    this.reloadUser(helper)
  }

  reloadUser = (helper) => {
    if (helper !== undefined) {
      helper.getProfileInfo((profile) => {
        this.setState(() => ({
          loggedIn: !!profile
        }))

        if (profile !== null) {
          this.setState(() => ({
            displayName: profile.display.display_name,
            avatarUrl: profile.display.avatar.url
          }))
        }
      })
    }
  }

  render() {
    const {loggedIn} = this.state

    return (
      <div className={styles.main}>
        <Header {...this.state} />
        <Features />
        <div>{loggedIn === false ? <Proposal /> : null}</div>
        <Products loggedIn={loggedIn} />
        <Footer />
      </div>
    )
  }
}

export default withStyles(styles)(App)
